export const COUNTRY_ARRAY_MODEL = ["CZ", "SK", "HU"];

export function sortCountries(countries: string[]): string[] {
  return countries.sort((a, b) => {
    const indexA = COUNTRY_ARRAY_MODEL.indexOf(a);
    const indexB = COUNTRY_ARRAY_MODEL.indexOf(b);
    return indexA !== -1 && indexB !== -1 ? indexA - indexB : indexA === -1 ? 1 : -1;
  });
}
